import { render, staticRenderFns } from "./TargetDirect.vue?vue&type=template&id=fae9803c"
import script from "./TargetDirect.vue?vue&type=script&lang=js"
export * from "./TargetDirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports